// extracted by mini-css-extract-plugin
export default {"container":"j4Hlw7tVFrHZKzDHoQCZ","modal":"yBAqGKPHeBDyneXCGICZ","head":"T4jTIYKuHwYOLNL9Kwks","body":"QeK7wDsfNEWsi9tezYEG"};